import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function SmsComplianceConsent() {
  return (
    <>
      <Helmet>
        <title>SMS Compliance & Consent Policy - TEJ Solutions Hub</title>
        <meta name="description" content="SMS compliance and consent policy for TEJ Solutions Hub. TCPA, CTIA, and A2P 10DLC compliant messaging services." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800' }}>SMS Compliance & Consent Policy</h1>
          <p style={{ fontSize: '1.1rem', opacity: '0.95' }}>Comprehensive Compliance Framework</p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '4rem 2rem' }}>
          <div style={{ background: '#d1fae5', padding: '2rem', borderRadius: '12px', marginBottom: '3rem', border: '2px solid #10b981' }}>
            <p style={{ fontSize: '1.1rem', color: '#065f46', lineHeight: '1.8', marginBottom: '0' }}>
              TEJ Solutions Hub is committed to full compliance with all SMS/email marketing regulations including TCPA, CTIA Guidelines, A2P 10DLC requirements, CAN-SPAM Act, and carrier-specific policies.
            </p>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Our Compliance Framework
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              As a full-service software development, digital marketing, and business financing referral company, we maintain strict compliance across all our messaging services:
            </p>
            <div style={{ display: 'grid', gap: '1rem', marginTop: '1.5rem' }}>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ TCPA Compliant</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Full compliance with Telephone Consumer Protection Act requirements for SMS marketing
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ CTIA Guidelines</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Adherence to Cellular Telecommunications Industry Association messaging best practices
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ A2P 10DLC Registered</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Registered and approved for Application-to-Person messaging on 10-digit long codes
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', border: '2px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ CAN-SPAM Compliant</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Email marketing services comply with CAN-SPAM Act requirements
                </p>
              </div>
            </div>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Our Communication Approach
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              <strong>TEJ SUSTAINABILITY GROUP, INC. (d/b/a TEJ Solutions Hub) uses Twilio to communicate with our customers.</strong> We send SMS and email messages directly to our customers and clients about our software development, digital marketing, and business financing referral services. All messages are sent via Twilio's messaging platform.
            </p>
            <div style={{ background: '#fef3c7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #fbbf24', marginTop: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#92400e', fontWeight: '600', marginBottom: '0.5rem' }}>
                Important: We obtain consent before sending communications.
              </p>
              <p style={{ fontSize: '1rem', color: '#78350f', lineHeight: '1.6', marginBottom: '0' }}>
                Contact information on our website is collected for business consultation, customer communications, and financing referral inquiries. We obtain proper consent before sending SMS or marketing emails to our customers.
              </p>
            </div>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Our Compliance Responsibilities
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              We are committed to maintaining full compliance when communicating with our customers:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem', marginBottom: '1rem' }}>
              <li><strong>Obtaining Valid Consent:</strong> Collecting express written consent from all recipients</li>
              <li><strong>Consent Documentation:</strong> Maintaining records of when, where, and how consent was obtained</li>
              <li><strong>Proper Disclosures:</strong> Providing all required information at the point of opt-in</li>
              <li><strong>Contact List Management:</strong> Ensuring our contact lists contain only consented recipients</li>
              <li><strong>Content Compliance:</strong> Ensuring message content complies with regulations</li>
              <li><strong>Opt-Out Honoring:</strong> Respecting opt-out requests immediately</li>
              <li><strong>Record Keeping:</strong> Maintaining compliance documentation for audit purposes</li>
            </ul>
            <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '8px', border: '2px solid #3b82f6', marginTop: '1.5rem' }}>
              <p style={{ fontSize: '1rem', color: '#1e40af', fontWeight: '600', lineHeight: '1.6', marginBottom: '0' }}>
                We only send communications to customers who have provided valid, documented opt-in consent and comply with all applicable regulations.
              </p>
            </div>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Consent Requirements
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              Valid SMS/email consent must include:
            </p>
            <div style={{ display: 'grid', gap: '1rem' }}>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>1. Clear Disclosure</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Clear statement that person is agreeing to receive SMS/email messages
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>2. Message Frequency</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Information about how often messages will be sent (or "frequency varies")
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>3. Cost Disclosure</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  "Message and data rates may apply" or similar language
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>4. Opt-Out Instructions</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  "Reply STOP to unsubscribe" or similar opt-out method
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>5. Help Information</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  "Reply HELP for help" or contact information for assistance
                </p>
              </div>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>6. No Purchase Requirement</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  "Consent is not a condition of purchase" (for promotional messages)
                </p>
              </div>
            </div>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Prohibited Practices
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              The following practices are strictly prohibited:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li>Using purchased, rented, or scraped contact lists</li>
              <li>Sending messages without documented opt-in consent</li>
              <li>Failing to honor opt-out requests</li>
              <li>Sending messages outside permitted hours (8 AM - 9 PM local time)</li>
              <li>Using deceptive or misleading content</li>
              <li>Sending prohibited content (illegal, adult, hate speech, etc.)</li>
              <li>Violating carrier or platform policies</li>
              <li>Sharing opt-out lists with third parties</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Our Compliance Measures
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              We implement comprehensive compliance measures for all customer communications:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li><strong>Automated Opt-Out Processing:</strong> STOP keywords processed immediately</li>
              <li><strong>Suppression Lists:</strong> Maintained across all campaigns</li>
              <li><strong>Message Logging:</strong> All messages logged for compliance auditing</li>
              <li><strong>Delivery Tracking:</strong> Real-time monitoring of message delivery</li>
              <li><strong>Carrier Compliance:</strong> Following all carrier-specific requirements</li>
              <li><strong>Content Filtering:</strong> Automated checks for prohibited content</li>
              <li><strong>Rate Limiting:</strong> Preventing message flooding</li>
              <li><strong>Time Restrictions:</strong> Enforcing permitted sending hours</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Email Marketing Compliance (CAN-SPAM)
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              Our email marketing services comply with the CAN-SPAM Act:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li>Accurate "From" and "Reply-To" information</li>
              <li>Non-deceptive subject lines</li>
              <li>Clear identification as advertisement (when applicable)</li>
              <li>Valid physical mailing address included</li>
              <li>Functional unsubscribe mechanism in every email</li>
              <li>Opt-out requests honored within 10 business days</li>
              <li>No email sending after opt-out</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Data Retention and Auditing
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              We maintain comprehensive records for compliance:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li><strong>Opt-In Records:</strong> Retained for minimum 4 years (TCPA requirement)</li>
              <li><strong>Opt-Out Records:</strong> Retained for minimum 4 years</li>
              <li><strong>Message Logs:</strong> Retained per carrier and regulatory requirements</li>
              <li><strong>Delivery Reports:</strong> Available for client review and auditing</li>
              <li><strong>Compliance Documentation:</strong> Maintained for regulatory audits</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Enforcement and Violations
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              We maintain the right to:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li>Suspend communications if compliance issues are identified</li>
              <li>Maintain comprehensive consent documentation</li>
              <li>Refuse to send messages that violate policies</li>
              <li>Report violations to appropriate authorities</li>
              <li>Cooperate with regulatory investigations</li>
            </ul>
          </div>

          <div style={{ background: '#fef3c7', padding: '2rem', borderRadius: '12px', border: '2px solid #fbbf24', marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem' }}>
              Questions or Concerns?
            </h3>
            <p style={{ fontSize: '1rem', color: '#78350f', lineHeight: '1.8', marginBottom: '1rem' }}>
              For compliance questions, opt-out requests, or to report violations:
            </p>
            <p style={{ fontSize: '1rem', color: '#78350f', lineHeight: '1.8', marginBottom: '0' }}>
              <strong>Email:</strong> contact@tejsolutionshub.com<br />
              <strong>Address:</strong> 4273 Savannah Trce, Atlanta, GA 30349<br />
              <strong>EIN:</strong> 86-3326707
            </p>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/sms-opt-in-disclosure" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              marginRight: '1rem'
            }}>
              SMS Opt-In Disclosure
            </Link>
            <Link to="/privacy-policy" style={{
              display: 'inline-block',
              background: 'white',
              color: '#7c3aed',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid #7c3aed'
            }}>
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
